angular.module('impactx.basket').controller('BasketItemDeletionBasketMandatoryCtrl', [
    '$scope',
    '$mdDialog',
    'TranslationService',
    'basket',
    'optionalBasketMandatoryDeletion',
    'selectedBasketItems',
    'headerLabel',
    'groupLabel',
    'referencesLabel',
    BasketItemDeletionBasketMandatoryCtrl]);

function BasketItemDeletionBasketMandatoryCtrl($scope, $mdDialog, TranslationService, basket, optionalBasketMandatoryDeletion, selectedBasketItems, headerLabel, groupLabel, referencesLabel)
{
    var self = this;
    $scope.basket = basket;
    $scope.deleteLabel = TranslationService.get("delete");
    $scope.abortLabel = TranslationService.get("abort");
    $scope.headerLabel = headerLabel;
    $scope.groupLabel = groupLabel;
    $scope.referencesLabel = referencesLabel;
    $scope.optionalBasketMandatoryDeletion = optionalBasketMandatoryDeletion;
    $scope.selectedBasketItems = selectedBasketItems;
    var oldSelectedBasketItems = JSON.parse(JSON.stringify(selectedBasketItems));

    this.updateSelectedItems = function (item, itemArray) {
        if (itemArray) {
            self.checkMandatoryMainItems(itemArray);
        }
        if (!item.selected) {
            var index = $scope.selectedBasketItems.indexOf(item);
            if (index > -1) {
                $scope.selectedBasketItems.splice(index, 1);
            }
        }
        else {
            var index = $scope.selectedBasketItems.indexOf(item);
            if (index < 0) {
                $scope.selectedBasketItems.push(item);
            }
        }
    };
    for (var j = 0; j < optionalBasketMandatoryDeletion.length; j++) {
        for (var k = 0; k < optionalBasketMandatoryDeletion[j].optionalItems.length; k++) {
            optionalBasketMandatoryDeletion[j].optionalItems[k].selectedReadOnly = false;
        }
    }

    this.checkMandatoryMainItems = function (itemArray) {
        var oneRefItemSelected = false;
        for (var i = 0; i < itemArray.length; i++) {
            var item = itemArray[i];
            if (item.selected && item.isBasketMandatoryRef)
            {
                oneRefItemSelected = true;
            }
        }
        for (var j = 0; j < itemArray.length; j++) {
            var mainItem = itemArray[j];
            mainItem.selectedReadOnly = false;
            if (!mainItem.isBasketMandatoryRef && oneRefItemSelected)
            {
                mainItem.selected = true;
                mainItem.selectedReadOnly = true;
                self.updateSelectedItems(mainItem, null);
            }
        }
    };

    for (var j = 0; j < optionalBasketMandatoryDeletion.length; j++) {
        self.checkMandatoryMainItems(optionalBasketMandatoryDeletion[j].optionalItems);
    }

    this.cancel = function ()
    {
        var revertedSelection = [];
        for (var i = 0; i < selectedBasketItems.length; i++) {
            var newItem = selectedBasketItems[i];
            newItem.selected = false;
        }

        angular.forEach(basket.basketSupplierHeaderList, function(supplierHeader) {
            angular.forEach(supplierHeader.basketItemList, function(item) {
                for (var i = 0; i < oldSelectedBasketItems.length; i++) {
                    var oldItem = oldSelectedBasketItems[i];
                    if (oldItem.id === item.id && oldItem.selected)
                    {
                        revertedSelection.push(item);
                        item.selected = true;
                    }
                }
            })
        });

        selectedBasketItems.length = 0;
        for (var i = 0; i < revertedSelection.length; i++) {
            selectedBasketItems.push(revertedSelection[i]);
        }
        $mdDialog.cancel();
    };
    this.answer = function ()
    {
        $mdDialog.hide();
    };
}